document.addEventListener('DOMContentLoaded', () => {

  const section = document.querySelector('.best-sellers');

  if (!section) return;

  /* ==========================
     Slider
  ========================== */

  const slider = section.querySelector('.best-sellers__grid');
  const prev = section.querySelector('.best-sellers__arrow--prev');
  const next = section.querySelector('.best-sellers__arrow--next');

  if (slider && prev && next) {

    next.addEventListener('click', () => {
      slider.scrollBy({
        left: slider.clientWidth,
        behavior: 'smooth'
      });
    });

    prev.addEventListener('click', () => {
      slider.scrollBy({
        left: -slider.clientWidth,
        behavior: 'smooth'
      });
    });

  }


  /* ==========================
     Check Product Availability
  ========================== */

  const checkAvailability = async (button) => {

    const variantId = button.dataset.variantId;

    if (!variantId) return;

    try {

      const response = await fetch(`/variants/${variantId}.js`);

      if (!response.ok) return;

      const variant = await response.json();

      if (!variant.available) {

        button.disabled = true;
        button.textContent = 'Sold Out';
        button.classList.add('is-sold-out');

      } else {

        button.disabled = false;
        button.textContent = 'Add to Cart';
        button.classList.remove('is-sold-out');

      }

    } catch (error) {

      console.log('Could not check product availability.');

    }

  };


  /* ==========================
     Initial Availability Check
  ========================== */

  section.querySelectorAll('.product-card__button[data-variant-id]').forEach(button => {
    checkAvailability(button);
  });


  /* ==========================
     Automatically Check Stock
     Every 30 Seconds
  ========================== */

  setInterval(() => {

    section.querySelectorAll('.product-card__button[data-variant-id]').forEach(button => {
      checkAvailability(button);
    });

  }, 30000);


  /* ==========================
     Add to Cart
  ========================== */

  section.querySelectorAll('.product-card__button[data-variant-id]').forEach(button => {

    button.addEventListener('click', async (e) => {

      e.preventDefault();

      if (button.disabled) return;

      const variantId = button.dataset.variantId;

      button.disabled = true;
      button.textContent = 'Adding...';

      try {

const response = await fetch('/cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  body: JSON.stringify({
    items: [
      {
        id: variantId,
        quantity: 1
      }
    ]
  })
});

const data = await response.json();

if (!response.ok) {
  throw new Error(
    data.description ||
    data.message ||
    'This item cannot be added to your cart.'
  );
}

/* Go directly to cart */
window.location.href = '/cart';

} catch (error) {

  button.textContent = 'Add to Cart';
  button.disabled = true;
  button.classList.add('is-sold-out');

  const card = button.closest('.product-card');
  const errorMessage = card?.querySelector('.product-card__error');

  if (errorMessage) {
    errorMessage.textContent = error.message;
    errorMessage.hidden = false;
  }

}

    });

  });

});